import { render, staticRenderFns } from "./courseTask.vue?vue&type=template&id=7c257516&scoped=true"
import script from "./courseTask.vue?vue&type=script&lang=js"
export * from "./courseTask.vue?vue&type=script&lang=js"
import style0 from "./courseTask.vue?vue&type=style&index=0&id=7c257516&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c257516",
  null
  
)

export default component.exports